module.exports = __webpack_public_path__ + "img/image 14.b07a68d5.png";